import { fetchWrapper } from '@/helpers';
import { useToast } from 'vue-toast-notification';
import { reactive } from 'vue';
import { useAuthStore } from '@/stores';
import i18n from '@/i18n';

const localApiUrl = process.env.VUE_APP_PROXY_SERVER + '/api/PageConfig';
const toast = useToast();
const t = i18n.global.t;

const pageConfigList = reactive([]);

class PageConfigApi {
  async searchPageConfig(page, size, keyword) {
    if (!keyword) {
      keyword = '';
    }

    return fetchWrapper.get(
      `${localApiUrl}/Search?page=${page}&size=${size}&keyword=${encodeURIComponent(
        keyword
      )}`
    );
  }

  async deletePageConfig(id) {
    var url = localApiUrl + '/Delete?id=' + id;

    return fetchWrapper.delete(url);
  }

  async createPageConfig(pageConfig) {
    return fetchWrapper.post(localApiUrl + '/Create', pageConfig);
  }

  async updatePageConfig(pageConfig) {
    return fetchWrapper.post(localApiUrl + '/Update', pageConfig);
  }

  async getPageConfig(id) {
    return fetchWrapper.get(localApiUrl + '/Get?id=' + id);
  }

  async getAllPageConfig(refresh = false) {
    if (refresh || pageConfigList.value == undefined) {
      pageConfigList.value = await fetchWrapper.get(localApiUrl + '/List');

      toast.open({
        message: `<strong>${t('common.notification')}</strong><br>${t(
          'common.fieldNameUpdated',
          {
            fieldName: t('ticket.masterData'),
          }
        )}`,
        type: 'success',
        duration: 5000,
        position: 'bottom-right',
      });
    }

    return JSON.parse(JSON.stringify(pageConfigList.value));
  }

  async checkUpdatePageConfig(lastUpdate) {
    const authStore = useAuthStore();
    var user_id = authStore.user.id;

    var result = await fetchWrapper.get(
      localApiUrl + '/LastUpdate?id=' + user_id
    );
    return result == lastUpdate;
  }
}
export default PageConfigApi;
